// @flow

import * as React from 'react';

import { BrowserRouter, Route, Switch } from 'react-router-dom';

import './style.scss';

import MainMenu from 'components/MainMenu';
import Footer from 'components/Footer';

import Home from 'views/Home';
import SearchResults from 'views/SearchResults';
import GreatReads from 'views/GreatReads';
import SideProjects from 'views/SideProjects';
import HowItWorks from 'views/HowItWorks';

const Root = () => (
  <BrowserRouter>
    <div className="site-wrapper">
      <MainMenu />
      <Switch>
        <Route path="/" exact component={Home} />
        <Route path="/great-reads" exact component={GreatReads} />
        <Route path="/how-it-works" exact component={HowItWorks} />
        <Route path="/side-projects" exact component={SideProjects} />
        <Route path="/search/:language/:popularity" component={SearchResults} />
      </Switch>
      <Footer />
    </div>
  </BrowserRouter>
);

export default Root;
